import { Pipe, PipeTransform, inject } from '@angular/core';

import { DatePipe } from '@angular/common';

import { HisBaseGlobalsService } from '../service/base/his-base-globals.service';

/**
 * HIS DatePipe
 * Dient vor allem dazu, dass eingestellte Anwendungslocale automatisch zu verwenden.
 * Mit diesem Locale wird dann an die Angular DatePipe delegiert.
 * Da Angular neben 'en-US' nur die in der 'his-core-module.ts' explizit importierten Locales unterstützt,
 * muss ein Mapping der HISinOne-Locales auf diese Locales passieren - das passiert in
 *  hisBaseGlobalsService.getNearestLocaleSupportedByClient().
 *
 * Wenn noch weitere, HIS-spezifische, Namen für Datumsformate erfunden werden sollen, können diese hier
 *  umgesetzt werden.
 */
@Pipe( {
    name: 'hisDate',
    standalone: false
} )
export class HisDatePipe implements PipeTransform {
    private hisBaseGlobalsService: HisBaseGlobalsService;


    private delegate: DatePipe;
    constructor() {
        const hisBaseGlobalsService = inject(HisBaseGlobalsService);

        this.hisBaseGlobalsService =  hisBaseGlobalsService || inject(HisBaseGlobalsService);
        let nearestSupportedLocale = this.hisBaseGlobalsService.getNearestLocaleSupportedByClient();
        this.delegate = new DatePipe( nearestSupportedLocale );
    }

    transform( value: any, format?: string, timezone?: string, locale?: string ): string | null {
        return this.delegate.transform( value, format, timezone, locale );
    }
}
